import React from "react";
import { Row, Typography } from "antd";

const { Title } = Typography;

interface ModalTitleProps {
  title: string;
  position?: "center" | "start" | "end";
}
const ModalTitle: React.FC<ModalTitleProps> = ({ title, position }) => {
  return (
    <Row justify={position ?? "start"} className="border-b">
      <Title level={4}>{title}</Title>
    </Row>
  );
};

export default ModalTitle;
